import { render, staticRenderFns } from "./UserAccountHeader.vue?vue&type=template&id=77803cc6&"
import script from "./UserAccountHeader.vue?vue&type=script&lang=js&"
export * from "./UserAccountHeader.vue?vue&type=script&lang=js&"
import style0 from "./UserAccountHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports